import React from "react";
import Header from "../Components/nav";
import Footer from "../Components/footer";
import Privacy from "../Components/privacy";
import Bottomfooter from "../Components/bottomfooter";

const PrivacyRoute = () => {
  return (
    <div>
      <Header />
      <Privacy />
      <Footer />
      {/* <Bottomfooter /> */}
    </div>
  );
};

export default PrivacyRoute;
